import {
  Button,
  Center, Grid, PasswordInput,
  Select,
  Space,
  TextInput, Title
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { Location, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import { api } from "../services/api";

export default function Signup({ company = false }){
  const { user, signIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 900px)');

  const [formData, setFormData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  const state = location.state as { from: Location };
  const from = state ? state.from.pathname : "/";

  const signup = (e) => {
    e.preventDefault();
    setLoading(true)    
    
    api.post(`/auth/signup${company ? '/company' : ''}`, formData)
    .then(({data : {user}}) => {
      setLoading(false);
      signIn(user, () => navigate(from, { replace: true }));
    })
    .catch(err => {
      setLoading(false);
      showNotification({title: "Ops", message: err.message, color: 'red'})
    })
  }

  const handleChange = (key) => (e) => {
    const {name, value} = e.target;
    setFormData(fd => ({...fd, [key]: { ...fd[key], [name]: value }}));
  }

  return !!user
  ? <Navigate to="/" state={{ from }} />
  : (
    <Center style={{ width: "100vw", height: isMobile ? 'unset' : "100vh", background: `linear-gradient(to top right, #ff7400, #ff7400, #ff7400)` }}>
      <div
        style={{
          width: isMobile ? '90vw' : company ? "60vw" : "40vw",
          padding: isMobile ? '2rem 0' : 'unset',
          display: "flex",
          flexDirection: "column"
        }}
      >
        <form onSubmit={signup}>
          <Grid>
            <Grid.Col sm={12} md={company ? 6 : 12}>
              <Title style={{color: 'white'}}>Dados do usuário</Title>
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="Nome" name="name" value={formData.user?.name} onChange={handleChange("user")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="CPF" name="cpf" value={formData.user?.cpf} onChange={handleChange("user")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="Telefone ou celular" name="phone" value={formData.user?.phone} onChange={handleChange("user")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="E-mail" name="email" type="email" value={formData.user?.email} onChange={handleChange("user")} />
              <PasswordInput styles={{ label: {color: 'white'} }} mt="md" label="Senha" name="password" type="password" value={formData.user?.password} onChange={handleChange("user")} />
              <PasswordInput styles={{ label: {color: 'white'} }} mt="md" label="Confirme a senha" name="password_confirmation" type="password" value={formData.user?.password_confirmation} onChange={handleChange("user")} />
            </Grid.Col>

            {company && <Grid.Col sm={12} md={6}>
              <Title style={{color: 'white'}}>Dados da empresa</Title>
              <Select
                mt="md"
                label="Tipo da entidade"
                name="type"
                styles={{ label: {color: 'white'} }}
                value={formData.company?.type}
                onChange={type => setFormData(fd => ({...fd, company: {...fd.company, type}}))}
                data={[
                  {label: "Empresa Privada", value: "empresa-privada"},
                  {label: "Órgão Público", value: "orgao-publico"},
                  {label: "Frente Parlamentar", value: "frente-parlamentar"},
                  {label: "Parlamentar", value: "parlamentar"},
                  {label: "Partido Político", value: "partido"},
                  {label: "Outros", value: "outro"},
                ]}
              />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="Nome" name="name" value={formData.company?.name} onChange={handleChange("company")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="CNPJ" name="cnpj" value={formData.company?.cnpj} onChange={handleChange("company")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="Telefone ou celular" name="phone" value={formData.company?.phone} onChange={handleChange("company")} />
              <TextInput styles={{ label: {color: 'white'} }} mt="md" label="E-mail" name="email" type="email" value={formData.company?.email} onChange={handleChange("company")} />
            </Grid.Col>}
          </Grid>
          
          <Space h="xl" />

          <div style={{textAlign: 'right'}}>
            <Button
              type="submit"
              loading={loading}
              style={{ color: '#6a6a6a' }}
              color="white"
              mt="xl"
            >Cadastrar</Button>
          </div>
        </form>
      </div>
    </Center>
  );
};
